import { agroApi } from "../../api";
import { ResponseDataGet } from "../../../../models/responseDataGet";
import { EntBasicHB } from "../../../../models/handBooks/basicHB";
import { EntInitialFilter } from "../../../../models/filters/initialFilter";
import { Paths } from "../../../../paths";

export const rawMaterialApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getRawMaterialList: builder.query<ResponseDataGet<EntBasicHB>, EntInitialFilter>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.rawMaterial }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getRawMaterialById: builder.query<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.rawMaterial }/${ id }`,
		method: 'GET',
	  }),
	}),

	addRawMaterial: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.rawMaterial }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editRawMaterial: builder.mutation<ResponseDataGet<EntBasicHB>, EntBasicHB>({
	  query: (body) => ({
		url: `${ Paths.handbooks.rawMaterial }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteRawMaterial: builder.mutation<ResponseDataGet<EntBasicHB>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.rawMaterial }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddRawMaterialMutation,
  useDeleteRawMaterialMutation,
  useEditRawMaterialMutation,
  useGetRawMaterialByIdQuery,
  useGetRawMaterialListQuery,
  useLazyGetRawMaterialListQuery
} = rawMaterialApi;
